const awsmobile = {
	aws_project_region: 'us-east-1',
	aws_appsync_graphqlEndpoint:
		'https://5lckrceyxnaohdl5yhahx7gy4q.appsync-api.us-east-1.amazonaws.com/graphql',
	aws_appsync_region: 'us-east-1',
	aws_appsync_authenticationType: 'AWS_IAM',
	aws_cognito_identity_pool_id:
		'us-east-1:22fdbd9a-5066-45c7-9d13-dc1b27b6a72e',
	aws_cognito_region: 'us-east-1'
};

export default awsmobile;
